// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { FloorExpansionMode } from "./floor-expansion-mode";

/**
 * Per-template expansion parameters.
 *
 * Numbering bases are per-template defaults; an explicitly set adapter-level
 * floor base wins (LN1 precedence).
 */
export class FloorExpansion implements flatbuffers.IUnpackableObject<FloorExpansionT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FloorExpansion {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFloorExpansion(bb: flatbuffers.ByteBuffer, obj?: FloorExpansion): FloorExpansion {
    return (obj || new FloorExpansion()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFloorExpansion(
    bb: flatbuffers.ByteBuffer,
    obj?: FloorExpansion,
  ): FloorExpansion {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FloorExpansion()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  mode(): FloorExpansionMode {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FloorExpansionMode.None_;
  }

  /**
   * Wire value at floor index 0 (DataOnly / PathAndData).
   */
  valueBase(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Number substituted for `{floor}` at floor index 0 (PathOnly / PathAndData).
   */
  pathBase(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  static startFloorExpansion(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addMode(builder: flatbuffers.Builder, mode: FloorExpansionMode) {
    builder.addFieldInt8(0, mode, FloorExpansionMode.None_);
  }

  static addValueBase(builder: flatbuffers.Builder, valueBase: number) {
    builder.addFieldInt32(1, valueBase, 0);
  }

  static addPathBase(builder: flatbuffers.Builder, pathBase: number) {
    builder.addFieldInt32(2, pathBase, 0);
  }

  static endFloorExpansion(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createFloorExpansion(
    builder: flatbuffers.Builder,
    mode: FloorExpansionMode,
    valueBase: number,
    pathBase: number,
  ): flatbuffers.Offset {
    FloorExpansion.startFloorExpansion(builder);
    FloorExpansion.addMode(builder, mode);
    FloorExpansion.addValueBase(builder, valueBase);
    FloorExpansion.addPathBase(builder, pathBase);
    return FloorExpansion.endFloorExpansion(builder);
  }

  unpack(): FloorExpansionT {
    return new FloorExpansionT(this.mode(), this.valueBase(), this.pathBase());
  }

  unpackTo(_o: FloorExpansionT): void {
    _o.mode = this.mode();
    _o.valueBase = this.valueBase();
    _o.pathBase = this.pathBase();
  }

  unpackFields(...fields: string[]): FloorExpansionT {
    const t = new FloorExpansionT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("mode")) {
      t.mode = this.mode();
    }
    if (fieldSet.has("value_base")) {
      t.valueBase = this.valueBase();
    }
    if (fieldSet.has("path_base")) {
      t.pathBase = this.pathBase();
    }
    return t;
  }
}

export class FloorExpansionT implements flatbuffers.IGeneratedObject {
  constructor(
    public mode: FloorExpansionMode = FloorExpansionMode.None_,
    public valueBase: number = 0,
    public pathBase: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return FloorExpansion.createFloorExpansion(builder, this.mode, this.valueBase, this.pathBase);
  }

  clone(): FloorExpansionT {
    const obj = new FloorExpansionT();
    obj.mode = this.mode;
    obj.valueBase = this.valueBase;
    obj.pathBase = this.pathBase;
    return obj;
  }

  equals(other: FloorExpansionT): boolean {
    if (this.mode !== other.mode) return false;
    if (this.valueBase !== other.valueBase) return false;
    if (this.pathBase !== other.pathBase) return false;
    return true;
  }
}

export function verifyFloorExpansion(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
  } finally {
    verifier.popDepth();
  }
}
